import axios, { AxiosResponse } from 'axios';

import AddLocationInput from 'modules/Global/models/AddLocationInput';

export default function createAsync(apiUrl: string) {
  return function api<TResponse>(
    input: AddLocationInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/locations`,
          method: 'POST',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
